import AlephBet from "alephbet"
import {storage_adapter, super_properties_lamed_adapter} from "./adapters"
import {premium_subscription_started} from "./goals"
import {
  get_user_id,
  logged_in_potential_customer,
  on_pricing_page
} from "./helpers"
import $ from "cash-dom"

export default () => {
  const replace_paragraph_text_with_benefits_bullet_list =
    new AlephBet.Experiment({
    name: "202507 Replace paragraph text with benefits bullet list #2",
    tracking_adapter: super_properties_lamed_adapter,
    user_id: get_user_id(),
    storage_adapter: storage_adapter,
    trigger: () => (on_pricing_page() && logged_in_potential_customer()),
    variants: {
      "1-Original": {
        activate: () => {
        }
      },
      "2-Variant": {
        activate: (experiment) => {
          if (!experiment.options.trigger()) return

          $("body").addClass("ab-replace-paragraph-text")
        }
      }
    }
  })

  replace_paragraph_text_with_benefits_bullet_list.add_goals([
    premium_subscription_started
  ])
}
